import { ImpersonateUserResponse, RefreshTokenResponse } from "@dune/types";
import { privateAxios, publicAxios } from "../axios";

export const impersonateUser = async (userId: number) => {
	const { data } = await privateAxios.post<ImpersonateUserResponse>(
		"/auth/impersonate",
		{
			userId,
		},
	);
	return data;
};

interface RefreshTokenRequest {
	refreshToken: string;
	email: string;
}

export const refreshAccessToken = async ({
	refreshToken,
	email,
}: RefreshTokenRequest) => {
	const { data } = await publicAxios.post<RefreshTokenResponse>(
		"/auth/refresh",
		{
			refreshToken,
			email,
		},
	);
	return data;
};
